import React, {Component} from 'react';
import {connect} from 'react-redux';
import {reduxForm} from 'redux-form';
import {Card, Button, Form} from 'semantic-ui-react';
import {Actions} from '../../../../common/actions';
import {USER_FORM} from '../../../../common/forms';
import {paths} from '../../../../common/dictionaries/urls';
import {TOYOTA_RUC} from '../../../../common/constants/dealer';
import ObservationModal from './modal/ObservationModal';
import DealerFields from './DealerFields';
import TdeFields from './TdeFields';

class UsersForm extends Component {
  updateStatusInfo = async(status) => {
    const {handleSubmit, setUserField} = this.props;
    await setUserField('status', status);
    handleSubmit();
  };

  /* validateUserProfiles = (formValues) => {
    const formKeys = Object.keys(formValues);
    const isProfileChecked = formKeys.some((key) => key.includes('group') && formValues[key]);
    return !isProfileChecked;
  } */
  validateUserProfiles = (formValues) => !(
    formValues.rolesList?.length > 0
  );

  renderButtons = (invalidProfiles) => {
    const {
      code,
      push,
      isUserFromTDE,
      username,
      loadingCheck,
      usernameError,
      submitting,
      formValues,
      isTdeUserNew,
    } = this.props;
    const isTdeUserEditable = username && TOYOTA_RUC.toString() === formValues.dealer;

    if (!isUserFromTDE && username) {
      return (
        <Button
          color='black'
          loading={submitting}
          type='submit'
          disabled={!formValues.username || invalidProfiles}
        >
          Enviar
        </Button>
      );
    } else if (isUserFromTDE && code) {
      return (
        <>
          <ObservationModal formValues={formValues} push={push} code={code} />
          <Button
            color='green'
            loading={submitting}
            onClick={() => this.updateStatusInfo('A')}
            disabled={loadingCheck || usernameError !== '' || invalidProfiles}
          >
            Crear
          </Button>
        </>
      );
    } else if (isUserFromTDE && isTdeUserNew && !username && !code) {
      return (
        <Button
          color="green"
          loading={submitting}
          type="submit"
          disabled={usernameError !== ''}
        >
          Crear usuario TDE
        </Button>
      );
    }
    return (
      <Button
        color='green'
        type='submit'
        loading={submitting}
        disabled={!isTdeUserEditable && invalidProfiles}
      >
        Guardar
      </Button>
    );
  }

  render() {
    const {
      handleSubmit,
      submitting,
      username,
      code,
      push,
      loading,
      formValues,
      isTdeUserNew,
      isUserFromTDE,
    } = this.props;
    const isTdeUser = isUserFromTDE && !username && !code;
    const invalidProfiles = this.validateUserProfiles(formValues);

    return (
      <Form
        className='edit-parameter-form'
        onSubmit={handleSubmit}
        loading={submitting || loading}
        disabled={username && !formValues.username}
      >
        <Card raised fluid>
          <div className='title-bar'>
            <div className='title'>
              <h2> {code || username ? 'Editar Usuario' : 'Añadir Usuario'}</h2>
              <div className='title-bar-actions'>
                <Button
                  secondary
                  type='button'
                  onClick={() => push(paths.UsersList)}
                  disabled={submitting}
                >
                  Cancelar
                </Button>
                {this.renderButtons(invalidProfiles)}
                {code && !isUserFromTDE && (
                  <Button
                    color='black'
                    loading={submitting}
                    disabled={invalidProfiles || loading}
                    onClick={() => this.updateStatusInfo('E')}
                  >
                    Enviar
                  </Button>
                )}
              </div>
            </div>
          </div>
          {isUserFromTDE ? (
            <TdeFields
              username={username}
              code={code}
              isTdeUser={isTdeUser}
              isTdeUserNew={isTdeUserNew}
            />
          ) : (
            <DealerFields username={username} />
          )}
        </Card>
      </Form>
    );
  }
}

export {UsersForm};

const form = reduxForm({
  'form': USER_FORM.name,
})(UsersForm);

const mapStateToProps = (state) => {
  return {
    'loading': state.userForm.loading || state.userForm.loadingPolicies,
    'loadingCheck': state.userForm.loadingCheck,
    'formValues': state.userForm.values,
    'isUserFromTDE': state.session.isUserFromTDE,
    'usernameError': state.userForm.usernameError,
    'isTdeUserNew': state.userForm.isTdeUserNew,
  };
};

const {checkUserInfo, setUserField} = Actions;

export default connect(mapStateToProps, {
  checkUserInfo,
  setUserField,
})(form);
